import React from 'react';
import {
    Card,
    CardContent,
    CardHeader,
    Typography,
    Button
} from '@mui/material';

const InfoModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div
            className="fixed inset-0 bg-black/50 flex items-center justify-center z-[9999]"
            onClick={onClose}
        >
            <Card
                className="w-[800px] max-h-[90vh] bg-white flex flex-col"
                onClick={(e) => e.stopPropagation()}
            >
                <CardHeader
                    title={
                        <Typography variant="h6">
                            Shopping List Information
                        </Typography>
                    }
                    className="flex-shrink-0"
                />
                <CardContent className="flex-1 overflow-auto">
                    <div className="space-y-4 text-md text-gray-600">
                        <p>
                            The shopping list represents the hedging strategies
                            and volumes for specific contracts and products
                            generated by our AI tool based on your demand
                            forecast.
                        </p>
                        <p>
                            Each shopping list entry contains detailed
                            information about contracts, products, volumes, and
                            hedging strategies to help you achieve optimal
                            pricing for your energy needs.
                        </p>
                        <p>A typical shopping list entry includes:</p>
                        <ul className="ml-6 space-y-1">
                            <li>
                                • <strong>Contract:</strong> The specific
                                contract name (e.g., CAL26)
                            </li>
                            <li>
                                • <strong>Product:</strong> The energy product
                                type (e.g., PEG)
                            </li>
                            <li>
                                • <strong>Volume:</strong> Total volume in MWh/h
                                (e.g., 100 MWh/h)
                            </li>
                            <li>
                                • <strong>Strategy:</strong> Applied hedging
                                strategy (e.g., Trailing Stop, Max Buy, Min Buy)
                            </li>
                            <li>
                                • <strong>Hedging Period:</strong> Start and end
                                dates for the hedging strategy
                            </li>
                            <li>
                                • <strong>Volume Status:</strong> Tracking of
                                bought vs. remaining volumes
                            </li>
                        </ul>
                        <p>
                            You can customize the parameters for each contract
                            and strategy according to your specific
                            requirements. The system continuously calculates
                            your exposure and risk for every product to help you
                            make informed trading decisions.
                        </p>
                        <p>
                            Use the hedging table to edit strategies, adjust
                            volumes, and execute buy orders directly from the
                            shopping list interface.
                        </p>
                    </div>
                </CardContent>
                <div className="flex justify-start p-4 flex-shrink-0 border-t">
                    <Button
                        onClick={onClose}
                        variant="contained"
                        color="primary"
                    >
                        Close
                    </Button>
                </div>
            </Card>
        </div>
    );
};

export default InfoModal;
